<script setup lang="ts">
const props = defineProps<{
	label?: string;
	isActive: boolean;
}>();
</script>

<template>
	<div
		class="bottom-dialog"
		:class="{ 'bottom-dialog--is-active': props.isActive }"
		role="dialog"
		aria-modal="true"
		:aria-label="props.label"
		:aria-labelledby="props.isActive ? 'bottom-dialog-more-title' : undefined"
		:aria-describedby="props.isActive ? 'bottom-dialog-more-description' : 'bottom-dialog-notification-description'"
	>
		<Transition name="transition--bottom-dialog" mode="out-in">
			<slot />
		</Transition>
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.bottom-dialog
	{
		@include flex;
		flex-direction:column;
		width:min(100%, 92rem);
		pointer-events:all;
		border:1px solid var(--border-primary);
		border-radius:var(--radius-2xl);
		background-color:color-opacity(var(--bg-primary), 48);
		box-shadow:var(--shadow-2xl);
		@include blur(3xl);
		padding:var(--spacing-md) var(--spacing-lg);
		overflow:hidden;
		transition:var(--transition-default);

		&--is-active
		{
			background-color:color-opacity(var(--bg-primary), 72);
		}
	}
}
</style>
